@if ((showingContentInSidebar$ | async) && !isOrganisationChanging) {
    <div class="h-100 d-flex flex-column"
         [attr.data-bs-theme]="themeService.currentThemeSwatch">
        <h1>Lumia Assistant</h1>
        <adapt-chat-ai [showAvatar]="false"
                       (totalCostChange)="totalCost = $event"></adapt-chat-ai>
        @if (shellUiService.controlShiftHeld$ | async) {
            <div class="mt-auto d-flex pt-2">
                <span class="ms-auto text-muted">Total cost: ${{ totalCost.toFixed(4) }}</span>
            </div>
        }
    </div>
} @else {
    <!-- Something here so ElementUtilities.isVisible can detect this and redirect -->
    <span class="text-muted">Loading...</span>
}
